import { computePlacementByMode, sceneRadiansToClockwiseDegrees, } from '@seddi/style-decoration';
/**
 * Initial piece-space transform for a logo in a region.
 * Uses the same default placement rules as product-image-generator / techpack
 * (`@seddi/style-decoration`): centered in the region. Artwork rotation stays 0
 * unless `rotationRadians` carries the logo's current scene rotation.
 *
 * `is2DProduct` is kept for call-site compatibility; default placement no longer
 * special-cases Chest/Back top-align (generators center unless the recipe sets align).
 */
export const getInitialTransformFromRegion = (region, logoSize, _is2DProduct, rotationRadians = 0) => {
    const logo = {
        processedSignedUrl: '',
        intrinsicSize: { width: logoSize.x, height: logoSize.y },
        fill: false,
        size: { x: logoSize.x, y: logoSize.y },
        transform: { rotation: sceneRadiansToClockwiseDegrees(rotationRadians) },
    };
    const { decoratorPlacement } = computePlacementByMode({
        logo,
        placementMode: 'default',
        resolvedRegion: {
            id: region.id,
            name: region.name,
            pieceName: region.pieceName,
            side: String(region.side),
            size: { x: region.size.x, y: region.size.y },
            transform: region.transform,
        },
        resolvedPom: null,
        placementLogoSize: { width: logoSize.x, height: logoSize.y },
        clampToRegion: true,
    });
    return {
        translation: { x: decoratorPlacement.x, y: decoratorPlacement.y },
        rotation: decoratorPlacement.rotation,
    };
};
